import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Dropdown from 'react-dropdown';

const UtilityPopup = ({modes, setMode, mode, name, clear, children, className}) => { 
    return (
        <div className={"piano-utility " + className}>
          <div className="utility-header">
            <Dropdown
              options={modes}
              onChange={(o) => setMode(o.value)}
              value={modes.find(x => x.value === mode)}
            />
            <div
              onClick={clear}
              className="clear-btn">x</div>
          </div>
          {children}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UtilityPopup);
